'use client'
import { HTMLProps } from 'react'
import clsx from 'classnames'
import { useTranslations } from 'next-intl'
import { motion } from 'framer-motion'
import { Link } from '@/routing'
import { Text } from '@/shared/ui'

import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import style from './read-more.module.scss'

interface PhotoProps extends HTMLProps<HTMLDivElement> {
  title: string
  link: string
}

export const ReadMore = (props: PhotoProps) => {
  const { className, title, link } = props
  const translate = useTranslations()

  const { ref: innerRef, animate } = useAppearance()

  return (
    <motion.div ref={innerRef} animate={animate} variants={variantsHeadline}>
      <Link className={clsx(style.container, className)} href={link}>
        <Text type="h2" color="main-blue">
          {translate('readMore')}
        </Text>
        <Text className={clsx(style.text)} type="h2" color="dark" __html={title} />
      </Link>
    </motion.div>
  )
}
